import(/* webpackMode: "eager" */ "/codebuild/output/src127982932/src/klic-frontend-v2/src/app/(client)/[name]/error.tsx")